import { render, staticRenderFns } from "./PaguPaket.vue?vue&type=template&id=f523684e&"
import script from "./PaguPaket.vue?vue&type=script&lang=js&"
export * from "./PaguPaket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports